require.context("./../../assets/icons", false, /\.svg$/);
